import React, { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Text,
  AccordionButton,
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionIcon,
  Box,
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
} from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const MatchingJd = ({ matchingJds = [], jobProfileName = "" }) => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (matchingJds.length > 0) {
      onOpen();
    }
  }, [matchingJds]);

  const onCancelHandler = () => {
    onClose();
    navigate("/home/create-job-profile");
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="xl"
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Matching Job Profiles</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Accordion allowToggle>
              {matchingJds.map((jd) => (
                <AccordionItem key={jd.PK}>
                  <h2>
                    <AccordionButton>
                      <Box flex="1" textAlign="left">
                        {jd.PK}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <TableContainer
                      style={{ height: "300px", overflow: "auto" }}
                    >
                      <Table size="sm">
                        <Tbody>
                          {jd.Keyword_String.split(",").map(
                            (Keyword_String, index) => (
                              <Tr key={index}>
                                <Td>{Keyword_String}</Td>
                              </Tr>
                            )
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </Accordion>
            <br />
            <Text fontSize="xs">
              <InfoIcon mb="1" /> {jobProfileName} will be created along with
              above matching job profiles.
              <Text ml={4}>Do you want to proceed?</Text>
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button
              variant="outline"
              mr={3}
              size="sm"
              onClick={onCancelHandler}
            >
              Cancel
            </Button>
            <Button colorScheme="blue" size="sm" onClick={onClose}>
              Proceed
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default MatchingJd;
